import React from "react";
import Box from "@mui/material/Box";
import { BannerData } from "types/models/master/MasterApp";
import { Fonts } from "shared/constants/AppEnums";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";

interface BannerProps {
  banner: BannerData;
  onBack?: () => void;
}

const BannerHeader: React.FC<BannerProps> = ({ banner, onBack }) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    if (onBack) {
      onBack();
    }
    navigate("/master/manageBanner");
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexDirection: { xs: "column", sm: "row" },
        pb: 5,
        mb: 2,
        borderBottom: "1px solid #E5E4EA",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={handleBackClick}
          sx={{
            textTransform: "none",
            color: "black",
            padding: 0,
            minWidth: "auto",
          }}
        />
        <Box
          component="h3"
          sx={{
            color: "text.primary",
            fontWeight: Fonts.BOLD,
            fontSize: 16,
            ml: 0.5,
            mb: { xs: 1, sm: 0 },
          }}
        >
          {banner?.id ? "Edit Banner" : "Add New Banner"}
        </Box>
      </Box>
    </Box>
  );
};

export default BannerHeader;
